var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"seat-row row--column"},_vm._l((_vm.columns),function(col,index){return _c('span',{key:("col_" + col + "_" + index),staticClass:"seat seat--empty seat--column",style:({
    '--fontFamily': _vm.style.fontFamily,
    '--fontColor1': _vm.style.fontColor1,
    '--fontColor2': _vm.style.fontColor2,
    '--fontColor3': _vm.style.fontColor3,
  })},[_vm._v(_vm._s(col))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d58b60d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ColumnList.vue
// module id = null
// module chunks = 